import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentPreferencesConfirmationPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesConfirmationPage";

/**
 * @name CaptureEDEStatementsEnrollmentConfirm
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentConfirm(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentPreferencesConfirmationPage />;
}